import cl from 'classnames';

import { IconsEnum } from '../../../../assets/icons/types';
import { Icon } from '../../../../helpers/Icon';
import { Translate } from '../../../../helpers/Translate';

import { composerKeys } from '../../../../locales/keys';

import { ComposerRenderGenerationCard } from '../ComposerRenderGenerationCard';
import type { ComposerGenerationItem } from '../ComposerRenderGenerationCard/ComposerRenderGenerationCard';

interface ComposerRenderSidebarProps {
  generations: ComposerGenerationItem[];
  activeViewId: string;
  sceneName?: string;
  onSelectView: (id: string) => void;
  onRemoveRender: (localId: string) => void;
  onStopRender: (localId: string) => void;
}

function ComposerRenderSidebar({
  generations,
  activeViewId,
  sceneName,
  onSelectView,
  onRemoveRender,
  onStopRender
}: ComposerRenderSidebarProps) {
  return (
    <div className="flex flex-col md:border-l dark:border-gray-700 md:w-80 4xl:w-112 md:h-full overflow-hidden">
      <div className="flex flex-col flex-1 overflow-hidden min-h-0">
        <div className="flex-1 px-2 py-2 overflow-y-auto space-y-3">
          {/* Composer scene card */}
          <div
            onClick={() => onSelectView('scene')}
            className={cl(
              'flex items-center gap-2.5 p-2 rounded-lg border cursor-pointer transition-colors',
              activeViewId === 'scene'
                ? 'bg-gray-100 dark:bg-gray-800 border-blue-400 dark:border-blue-500'
                : 'bg-gray-100 dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-750'
            )}
          >
            <div className="w-10 h-10 rounded bg-white dark:bg-gray-900 shrink-0 flex items-center justify-center border border-gray-200 dark:border-gray-700 overflow-hidden">
              <Icon
                className="h-6 w-6 text-gray-500"
                icon={IconsEnum.SQUARE_3_STACK_3D}
              />
            </div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              <Translate id={composerKeys.singular} />
            </span>
          </div>

          <hr className="border-gray-200 dark:border-gray-700 -mx-2" />
          <p className="text-2xs font-medium text-gray-500 dark:text-gray-400 px-1 pt-1 uppercase tracking-wide">
            <Translate id={composerKeys.createdRenders} />
          </p>

          {/* Render & lifestyle generation cards */}
          {generations.map((item) => (
            <ComposerRenderGenerationCard
              key={item.localId}
              item={item}
              isActive={activeViewId === item.localId}
              sceneName={sceneName}
              onSelectView={onSelectView}
              onRemoveRender={onRemoveRender}
              onStopRender={onStopRender}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ComposerRenderSidebar;
